import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import MessyMiddle from "@/pages/MessyMiddle";
import AboutAlex from "@/pages/AboutAlex";
import WorkWithAlex from "@/pages/WorkWithAlex";
import Organisations from "@/pages/Organisations";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";

let lenisInstance = null;

const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisInstance = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);
  return null;
};

const ScrollReset = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenisInstance) lenisInstance.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <ScrollReset />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/messy-middle" element={<MessyMiddle />} />
          <Route path="/about" element={<AboutAlex />} />
          <Route path="/work-with-alex" element={<WorkWithAlex />} />
          <Route path="/organisations" element={<Organisations />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
